
export default (el, html) => {
    if(el) {
        el.innerHTML = html
    }
}